import { PropertyModel } from 'common/data/property/model';
import { PropertyCategoryIdentifierEnum } from 'common/data/property-category/identifier.enum';
import { i18nTranslate } from 'common/helper/i18n/translate';

export const propertyCardSeoText = (property: PropertyModel): string => {
  let bedroomText = '';
  const bathroomText =
    property.bathroom_value === 1
      ? `- ${i18nTranslate('bathroom_count').replace('{count}', String(property.bathroom_value))} `
      : property.bathroom_value > 1
      ? `- ${i18nTranslate('bathrooms_count').replace('{count}', String(property.bathroom_value))} `
      : '';
  const propertyCategoryText =
    property.category_identifier === PropertyCategoryIdentifierEnum.residentialForSale ||
    property.category_identifier === PropertyCategoryIdentifierEnum.commercialForSale
      ? i18nTranslate('for sale')
      : i18nTranslate('for rent');
  const locationText = property.location_tree_path
    ? i18nTranslate('in') + ' ' + property.location_tree_path.replace(/,/g, ' -')
    : '';

  if (
    property.category_identifier === PropertyCategoryIdentifierEnum.residentialForRent ||
    property.category_identifier === PropertyCategoryIdentifierEnum.residentialForSale
  ) {
    bedroomText =
      property.bedroom_value === 0
        ? `- ${property.bedroom_name} `
        : property.bedroom_value === 1
        ? `- ${i18nTranslate('bedroom_count').replace('{count}', String(property.bedroom_value))} `
        : property.bedroom_value === 2
        ? `- ${i18nTranslate('bedrooms_count_2').replace('{count}', String(property.bedroom_value))} `
        : property.bedroom_value > 2
        ? `- ${i18nTranslate('bedrooms_count').replace('{count}', String(property.bedroom_value))} `
        : '';
  }
  return `${property.property_type.name} ${bedroomText}${bathroomText}${propertyCategoryText} ${locationText}`
    .replace(/&/g, 'and')
    .trim();
};
